
export default {
  async getRequest(context, payload, apiPath) {
    var token = context.rootGetters['auth/getToken']
    var bearer_token = "Bearer " + token;
    var apiUrl = context.rootGetters['config/getApiUrl']
    var url = `${apiUrl}/${apiPath}`;

    // console.log("COMMON GET REQ - url", url)    
    // console.log("TOKEN", bearer_token)
    
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: bearer_token,
        "Content-Type": "application/json",
      },
    });
    
    // console.log ("COMMON - getRequest - response")
    // console.log (response)
    if (!response.ok) {
      // a 401 logs the user out and returns to login: see utils/session-guard.js
      //error, NOT ok
      const error = new Error("Failed to fetch.");
      throw error;
    }
    const responseJson = await response.json();
    return responseJson;
  },

   async postRequest(context, payload, apiPath) {
    var token = context.rootGetters['auth/getToken']
    var bearer_token = "Bearer " + token;
    var apiUrl = context.rootGetters['config/getApiUrl']
    var url = `${apiUrl}/${apiPath}`;
    
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: bearer_token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      // a 401 logs the user out and returns to login: see utils/session-guard.js
      //error, NOT ok
      const error = new Error("Failed to fetch.");
      throw error;
    }
    const responseJson = await response.json();
    return responseJson;
  },

   async putRequest(context, payload, apiPath) {
    var token = context.rootGetters['auth/getToken']
    var bearer_token = "Bearer " + token;
    var apiUrl = context.rootGetters['config/getApiUrl']
    var url = `${apiUrl}/${apiPath}`;

    const response = await fetch(url, {
      method: "PUT",
      headers: {
        Authorization: bearer_token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      //error, NOT ok
      const error = new Error("Failed to fetch.");
      throw error;
    }
    // A PUT may legitimately answer 204 No Content.
    if (response.status === 204) return null;
    const text = await response.text();
    if (!text) return null;
    try {
      return JSON.parse(text);
    } catch (error) {
      return null;
    }
  },

  async deleteRequest(context, apiPath) {
    var token = context.rootGetters['auth/getToken']
    var bearer_token = "Bearer " + token;
    var apiUrl = context.rootGetters['config/getApiUrl']
    var url = `${apiUrl}/${apiPath}`;

    const response = await fetch(url, {
      method: "DELETE",
      headers: {
        Authorization: bearer_token,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      //error, NOT ok
      const error = new Error(`Failed to delete (${response.status}).`);
      throw error;
    }
    // A DELETE commonly answers 204 No Content.
    if (response.status === 204) return null;
    const text = await response.text();
    if (!text) return null;
    try {
      return JSON.parse(text);
    } catch (error) {
      return null;
    }
  },

  // The Metric claim on the token decides which set of names the UI shows.
  // Everything downstream reads propertyName, so for an imperial user we move
  // the metric name aside into propertyNameMetric and promote the imperial
  // name into propertyName. A metric user is left untouched.
  applyUnitNames(context, rows) {
    if (!Array.isArray(rows)) return rows;
    if (context.rootGetters['auth/getUseMetric']) return rows;

    return rows.map((row) => {
      if (!row || row.propertyName === undefined) return row;
      return {
        ...row,
        propertyNameMetric: row.propertyName,
        // no imperial name on this property, so keep the one we have
        propertyName: row.propertyNameImperial || row.propertyName,
      };
    });
  },

  // Code that looks a property up by name has always used the metric name.
  // After the swap that name sits in propertyNameMetric; for a metric user it
  // never moved. Match on either so the lookup holds in both unit systems.
  isProperty(prop, metricName) {
    if (!prop) return false;
    return (
      prop.propertyNameMetric === metricName || prop.propertyName === metricName
    );
  },

  // The API hands back a property already named for the user's unit system
  // ("Volume (L)" or "Volume (gal)"), so the unit to print alongside a value is
  // whatever sits in that name's trailing parenthesis. Empty when it has none.
  unitOf(propertyName) {
    const match = /\(([^)]+)\)\s*$/.exec(propertyName || "");
    if (!match) return "";
    const unit = match[1].trim();
    // "Volume (%)" is a share, not a unit that follows a space.
    return unit === "%" ? "%" : unit;
  },

  testMobile()
  {
    let check = function() {
      let check = false;
      // eslint-disable-next-line
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    };
    
    return check();

  },
};
